<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright1"><strong>P<span class="small">RAISE FOR</span> B<span class="small">ORN ON A</span> R<span class="small">OTTEN</span> D<span class="small">AY</span></strong></p>
<div class="blockquote">
<p class="noindent">“<em>Born On a Rotten Day</em> delivers the dirt on every sign and then some! A fun, fast-paced, and frantically funny read.”</p>
<p class="attribution">—Stuart Hazleton, author of <em>Sexscopes</em></p></div>
<div class="blockquote">
<p class="noindent">“A wry, clever look at the Darth Vader side of the zodiac.”</p>
<p class="attribution">—Trish McGregor, author of <em>Creative Stars: Using Astrology to Tap Your Muse</em></p></div>
<div class="blockquote">
<p class="noindent">“When you get to that place in your life when you’re ready to hear the truth about yourself, read this book and laugh.”</p>
<p class="attribution">—Judith Turner, author of <em>The Hidden World of Birthdays</em></p></div>
<div class="blockquote">
<p class="noindent">“Hazel’s insightful zingers perfectly describe every person who has ever pissed me off.”</p>
<p class="attribution">—Peter Bailey, webmaster/publisher of www.metamaze.com</p></div>
<div class="blockquote">
<p class="noindent">“Hazel Dixon-Cooper has taken a perceptive, humorous look at the seamy underbelly of every sign. Her book is spot on for every sign … except for Sagittarius. We Sadges are perfect! Ha ha ha … [<em>burp</em>]!”</p>
<p class="attribution">—Charlene Lichtenstein, author of <em>Herscopes</em></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praise.vue?2bc16bf4